import React from 'react'
import { Box, Text, HStack, Button, Flex } from '@chakra-ui/react'
import { FiArrowLeft, FiUser } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { useClientView } from '../../contexts/ClientViewContext'
import { useActiveProfile } from '../../contexts/ActiveProfileContext'
import { useAuth } from '../../contexts/AuthContext'

interface ClientViewBannerProps {
  /** Callback after returning to clients list */
  onReturn?: () => void
}

export const ClientViewBanner: React.FC<ClientViewBannerProps> = ({ onReturn }) => {
  const navigate = useNavigate()
  const { isViewingClient, viewedClientProfile, exitClientView } = useClientView()
  const { setActiveProfile, allProfiles } = useActiveProfile()
  const { userAccount } = useAuth()

  const handleReturnToClients = async () => {
    // Switch back to the Pro user's default profile
    const defaultProfileId = userAccount?.defaultProfileId
    if (defaultProfileId) {
      const defaultProfile = allProfiles.find(p => p.profileId === defaultProfileId)
      if (defaultProfile) {
        await setActiveProfile(defaultProfileId)
      }
    }
    
    exitClientView()
    navigate('/pro/clients')
    onReturn?.()
  }

  if (!isViewingClient || !viewedClientProfile) {
    return null
  }

  return (
    <Box
      position="fixed"
      top="64px"
      left={0}
      right={0}
      zIndex="banner"
      bg="purple.600"
      color="white"
      px={4}
      py={2}
      borderBottom="1px solid"
      borderColor="purple.700"
      boxShadow="sm"
    >
      <Flex 
        justify="space-between" 
        align="center" 
        maxW="7xl" 
        mx="auto"
        gap={4}
      >
        <HStack gap={3} align="center" flex={1} minW={0}>
          <Box
            as={FiUser}
            boxSize={4}
            color="white"
            flexShrink={0}
          />
          <Text 
            fontWeight="medium" 
            fontSize="sm" 
            lineHeight="shorter"
            truncate
          >
            Viewing client: <Text as="span" fontWeight="bold">{viewedClientProfile.name}</Text>
          </Text>
        </HStack>
        
        <Button
          size="sm"
          variant="solid"
          bg="whiteAlpha.200"
          color="white"
          borderWidth="1px"
          borderColor="whiteAlpha.300"
          _hover={{ 
            bg: 'whiteAlpha.300',
            borderColor: 'whiteAlpha.400',
          }}
          onClick={handleReturnToClients}
          flexShrink={0}
        >
          <FiArrowLeft style={{ marginRight: '6px' }} />
          Back to Clients
        </Button>
      </Flex>
    </Box>
  )
}

export default ClientViewBanner

